import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import students1 from "../../assets/img/students1.webp";
import students2 from "../../assets/img/students2.webp";
import students3 from "../../assets/img/students3.webp";
import students4 from "../../assets/img/students4.webp";
import students5 from "../../assets/img/students5.webp";

const TestimonialCarousel = () => {
    return (
        <div className="container-fluid py-5">
            <div className="container py-5">
                <div className="text-center mb-5">
                    <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>
                        Testimonios
                    </h5>
                    <h1>¿Qué dicen nuestros estudiantes?</h1>
                </div>

                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    navigation
                >
                    <SwiperSlide>
                        <div className="text-center">
                            <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                            <div className="testimonial-text">
                                <h4 className="font-weight-normal mb-4">
                                    El curso de Aprende programación  de software en sólo 4 semanas superó mis
                                    expectativas. Al principio, estaba intimidado por el mundo de la programación, pero el
                                    enfoque claro y práctico del curso me ayudó a entender los conceptos básicos de manera
                                    sencilla y efectiva.
                                </h4>
                            </div>
                            <img className="testimonial-img mx-auto mb-3" src={students1} alt="Estudiante 1" />
                            <h5 className="m-0">Jose Enrique Romero</h5>
                            <span>Emprendedor</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="text-center">
                            <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                            <div className="testimonial-text">
                                <h4 className="font-weight-normal mb-4">
                                    Se me hizo super dificil entender en el aula de clases
                                    de la universidad. Con este curso logré entender mucho mejor lo basico de la
                                    programación para avanzar
                                </h4>
                            </div>
                            <img className="testimonial-img mx-auto mb-3" src={students2} alt="Estudiante 2" />
                            <h5 className="m-0">Andrea Gomez Salazar</h5>
                            <span>Estudiante</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="text-center">
                            <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                            <div className="testimonial-text">
                                <h4 className="font-weight-normal mb-4">
                                    Me parecio espectacular que el profesor de Liderazgo
                                    tuviera tanta empatía para hacerlos entender muchas cosas. Ademas me encanto la
                                    flexibilidad de horarios y lo rápido
                                </h4>
                            </div>
                            <img className="testimonial-img mx-auto mb-3" src={students3} alt="Estudiante 3" />
                            <h5 className="m-0">Jorge Sanchez</h5>
                            <span>Administrador</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="text-center">
                            <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                            <div className="testimonial-text">
                                <h4 className="font-weight-normal mb-4">
                                    Soy de la 1ra cohorte del curso de programacion basico,
                                    la verdad el profesor explica muy bien. Ahora puedo entender muchas cosas que en la U se
                                    me complicaba mucho
                                </h4>
                            </div>
                            <img className="testimonial-img mx-auto mb-3" src={students4} alt="Estudiante 3" />
                            <h5 className="m-0">Santiago Giraldo</h5>
                            <span>Estudiante</span>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="text-center">
                            <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                            <div className="testimonial-text">
                                <h4 className="font-weight-normal mb-4">
                                    Lo que más me gustó del curso es que lo pude hacer en el horario que tenia tiempo porque trabajo de noche. El precio me parecio bien ya que otros cursos me costaban hasta 530$
                                </h4>
                            </div>
                            <img className="testimonial-img mx-auto mb-3" src={students5} alt="Estudiante 3" />
                            <h5 className="m-0">Juan L. Cardona</h5>
                            <span>Estudiante</span>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    );
};

export default TestimonialCarousel;
